<template>
    <input :id="label" class="p-3 text-dark border-solid border-2 border-grey-200 rounded w-full block focus:border-primary focus-visible:outline-none" type="file" accept="image/*" @change="onChangedFile($event)">
</template>

<script>
export default {
    name: "ImageUpload",
    props: {
        modelValue: File,
        label: String,
        error: String
    },
    computed: {
        previewImage() {
            if (!this.modelValue) return null;

            return URL.createObjectURL(this.modelValue);
        },
        imagePreviewStyle() {
            return {
                backgroundImage: `url(${this.previewImage})`
            };
        },
    },
    methods: {
        onChangedFile($event) {
            const file = $event.target.files[0];

            this.emitFile(file);
        },
        emitFile(file) {
            this.$emit('update:modelValue', file);
        }
    },
}
</script>

<style scoped>
</style>
